import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import Text from '../../../Text'
import {
  useCalendarGridContext,
  useCalendarGridItemHandlers,
} from '../../CalendarGrid.hooks'
import { getIsCalendarGridPinnedSecondaryLabelClickable } from '../../CalendarGrid.utils'
import { getCalendarGridItemTimeLabel } from '../../CalendarGrid.utils.time'
import { CalendarGridItemStatus } from '../../CalendarGridItemStatus'

import {
  QA_NAME_CALENDAR_GRID_DAY_POPOVER_COMPACT_ROW,
  QA_NAME_CALENDAR_GRID_DAY_POPOVER_COMPACT_ROW_SECONDARY_LABEL,
} from './CalendarGridDayPopoverCompactRow.constants'
import {
  getCalendarGridCompactRowLabel,
  getIsCalendarGridItemStatusInDayList,
} from './CalendarGridDayPopoverCompactRow.utils'

import * as styles from './CalendarGridDayPopoverCompactRow.module.css'

function CalendarGridDayPopoverCompactRow({
  isTagShown,
  item = EMPTY_OBJECT,
  locale,
  timezone,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { t } = useTranslation()

  const { ItemTag } = useCalendarGridContext()

  const isLabelClickable = getIsCalendarGridPinnedSecondaryLabelClickable({
    item,
    onClickSecondaryLabel,
  })

  const { handleClickItem, handleClickSecondaryLabel } =
    useCalendarGridItemHandlers({
      isSecondaryLabelClickable: isLabelClickable,
      item,
      onClickItem,
      onClickSecondaryLabel,
    })

  const { id, isAllDay } = item

  return (
    <div
      {...getQaSelector({
        context: id,
        value: QA_NAME_CALENDAR_GRID_DAY_POPOVER_COMPACT_ROW,
      })}
      className={styles.CalendarGridDayPopoverCompactRow}
      onClick={handleClickItem}
    >
      {isTagShown && ItemTag ? <ItemTag item={item} /> : null}
      {isAllDay ? null : (
        <Text className={styles.time}>
          {getCalendarGridItemTimeLabel({ item, locale, t, timezone })}
        </Text>
      )}
      <Text
        className={classNames(styles.label, {
          [styles.clickable]: isLabelClickable,
        })}
        qaName={QA_NAME_CALENDAR_GRID_DAY_POPOVER_COMPACT_ROW_SECONDARY_LABEL}
        onClick={handleClickSecondaryLabel}
      >
        {getCalendarGridCompactRowLabel(item)}
      </Text>
      {getIsCalendarGridItemStatusInDayList(item) ? (
        <CalendarGridItemStatus className={styles.status} item={item} />
      ) : null}
    </div>
  )
}

export default CalendarGridDayPopoverCompactRow
